import React from "react";

const faq = () => {
  return (
    <div className="fq-bac">
      <div>
        <div className="flex w-full flex-col justify-center items-center">
          <div className="col-4"></div>
          <div>
            <h4 className="faq-header">Curious? see</h4>
            <h4 className="faq-header2">our FAQs</h4>
          </div>
          <div className="col-4"></div>
        </div>
      </div>

      <div className="lg:px-12 px-6 mt-10">
        <div>
          <div className="flex lg:gap-[6rem] gap-[2rem] lg:flex-row flex-col-reverse">
            <div className="bac-fac-q">
              <div
                class="nav flex-column nav-pills me-3"
                id="v-pills-tab"
                role="tablist"
                aria-orientation="vertical"
              >
                <button
                  class="nav-link active text-justify"
                  id="v-pills-home-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#v-pills-home"
                  type="button"
                  role="tab"
                  aria-controls="v-pills-home"
                  aria-selected="true"
                >
                  <p className="lg:mx-6 mx-2"> Why Cuppycode?</p>
                </button>
                <button
                  class="nav-link text-justify"
                  id="v-pills-profile-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#v-pills-profile"
                  type="button"
                  role="tab"
                  aria-controls="v-pills-profile"
                  aria-selected="true"
                >
                  <p className="lg:mx-6 mx-2"> What is Cuppycode?</p>
                </button>
                <button
                  class="nav-link text-justify"
                  id="v-pills-disabled-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#v-pills-disabled"
                  type="button"
                  role="tab"
                  aria-controls="v-pills-disabled"
                  aria-selected="false"
                >
                  <p className="lg:mx-6 mx-2"> Who is a Bettor?</p>
                </button>
                <button
                  class="nav-link text-justify"
                  id="v-pills-messages-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#v-pills-messages"
                  type="button"
                  role="tab"
                  aria-controls="v-pills-messages"
                  aria-selected="false"
                >
                  <p className="lg:mx-6 mx-2"> Who is a tipster?</p>
                </button>
                <button
                  class="nav-link text-justify"
                  id="v-pills-settings-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#v-pills-settings"
                  type="button"
                  role="tab"
                  aria-controls="v-pills-settings"
                  aria-selected="false"
                >
                  <p className="lg:mx-6 mx-2">
                    {" "}
                    Can I get free booking codes to copy?
                  </p>
                </button>
                <button
                  class="nav-link text-justify"
                  id="v-pills-message-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#v-pills-message"
                  type="button"
                  role="tab"
                  aria-controls="v-pills-message"
                  aria-selected="false"
                >
                  <p className="lg:mx-6 mx-2">
                    Can I be both a Bettor and a tipster?
                  </p>
                </button>
                <button
                  class="nav-link text-justify"
                  id="v-pills-setting-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#v-pills-setting"
                  type="button"
                  role="tab"
                  aria-controls="v-pills-setting"
                  aria-selected="false"
                >
                  <p className="lg:mx-6 mx-2">
                    How do I make money with Cuppycode?
                  </p>
                </button>
                <button
                  class="nav-link text-justify"
                  id="v-pills-tip-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#v-pills-tip"
                  type="button"
                  role="tab"
                  aria-controls="v-pills-tip"
                  aria-selected="false"
                >
                  <p className="lg:mx-6 mx-2">What’s a Tipster Table?</p>
                </button>
              </div>
            </div>
            <div
              class="tab-content lg:w-[60%] w-full border-[3px] lg:h-[250px] h-[200px] mt-4 lg:rounded-[60px] rounded-[50px] lg:px-10 px-6 bprder-[#fff]"
              id="v-pills-tabContent"
            >
              <div
                class="tab-pane fade show active"
                id="v-pills-home"
                role="tabpanel"
                aria-labelledby="v-pills-home-tab"
                tabindex="0"
              >
                <div className="bb lg:text-[25px] text-[16px] ">
                  Cuppycode offers more winning opportunities and rewards for the
                  time you invest in analyzing betting outcomes.
                </div>
              </div>

              <div
                class="tab-pane fade"
                id="v-pills-profile"
                role="tabpanel"
                aria-labelledby="v-pills-profile-tab"
                tabindex="0"
              >
                <div className="bb">
                  Cuppycode is a community of betting enthusiasts, from beginners
                  to pros, aiming <br></br> to improve their chances of winning
                  and earn rewards by sharing booking codes.
                </div>
              </div>

              <div
                class="tab-pane fade"
                id="v-pills-disabled"
                role="tabpanel"
                aria-labelledby="v-pills-disabled-tab"
                tabindex="0"
              >
                <div className="bb">
                  At Cuppy Bet, a Bettor is someone who joins the platform{" "}
                  <br></br>to copy booking codes in order to win bets.
                </div>
              </div>

              <div
                class="tab-pane fade"
                id="v-pills-messages"
                role="tabpanel"
                aria-labelledby="v-pills-messages-tab"
                tabindex="0"
              >
                <div className="bb">
                  A tipster at Cuppycode is an experienced expert <br></br> who
                  analyzes games and shares booking codes to help others win.
                </div>
              </div>

              <div
                class="tab-pane fade"
                id="v-pills-settings"
                role="tabpanel"
                aria-labelledby="v-pills-settings-tab"
                tabindex="0"
              >
                <div className="bb">
                  Absolutely! You can find free booking codes on the top part of
                  these page<br></br> or the "Free Odds" tab in the Mobile App.
                </div>
              </div>

              <div
                class="tab-pane fade"
                id="v-pills-message"
                role="tabpanel"
                aria-labelledby="v-pills-message-tab"
                tabindex="0"
              >
                <div className="bb">Yes, you can be both! 😎</div>
              </div>

              <div
                class="tab-pane fade"
                id="v-pills-setting"
                role="tabpanel"
                aria-labelledby="v-pills-setting-tab"
                tabindex="0"
              >
                <div className="bb">
                  You can make money by selling each booking code on "Pro Odds"
                  for <br></br> any amount you wish or by selling a Prenium
                  monthly subscription.<tag> Lunching soon 💥🔥</tag>
                </div>
              </div>

              <div
                class="tab-pane fade"
                id="v-pills-tip"
                role="tabpanel"
                aria-labelledby="v-pills-tip-tab"
                tabindex="0"
              >
                <div className="bb">
                  A Tipster Table displays statistics of top-ranked tipsters{" "}
                  <br></br> with proven records of winning bets.
                  <tag> Lunching soon 💥🔥</tag>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default faq;
